import { isOperationalCoordinationMode } from '../operationalCoordination/operationalCoordinationFlags';

export function isOperationalRecoveryMode(): boolean {
  const v = process.env.REACT_APP_OPERATIONAL_RECOVERY;
  if (v === 'false') return false;
  return v === 'true' || isOperationalCoordinationMode();
}
